import React from 'react';
import Input from '../Input';

interface PersonalDataSectionProps {
  formData: {
    firstName: string;
    lastName: string;
    birthPlace: string;
    birthProvince: string;
    birthDate: string;
    role: string;
  };
  errors: Record<string, string>;
  onChange: (field: string, value: string) => void;
}

const PersonalDataSection: React.FC<PersonalDataSectionProps> = ({
  formData,
  errors,
  onChange
}) => {
  return (
    <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-sm ring-1 ring-black/5 dark:ring-white/10 p-6 sm:p-8">
      <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-6">
        Dati Rappresentante Legale
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Nome *"
          type="text"
          value={formData.firstName}
          onChange={(e) => onChange('firstName', e.target.value)}
          error={errors.firstName}
          fullWidth
          required
        />

        <Input
          label="Cognome *"
          type="text"
          value={formData.lastName}
          onChange={(e) => onChange('lastName', e.target.value)}
          error={errors.lastName}
          fullWidth
          required
        />

        <Input
          label="Nato a *"
          type="text"
          value={formData.birthPlace}
          onChange={(e) => onChange('birthPlace', e.target.value)}
          error={errors.birthPlace}
          fullWidth
          required
        />

        <Input
          label="Provincia * (es. RM)"
          type="text"
          value={formData.birthProvince}
          onChange={(e) => onChange('birthProvince', e.target.value.toUpperCase())}
          error={errors.birthProvince}
          maxLength={2}
          placeholder=""
          fullWidth
          required
        />

        <Input
          label="Data di nascita *"
          type="date"
          value={formData.birthDate}
          onChange={(e) => onChange('birthDate', e.target.value)}
          error={errors.birthDate}
          placeholder=" "
          fullWidth
          required
        />

        <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            In qualità di *
          </label>
          <select
            value={formData.role}
            onChange={(e) => onChange('role', e.target.value)}
            className={`w-full px-4 py-3 rounded-lg border ${
              errors.role
                ? 'border-red-500 focus:ring-red-500'
                : 'border-gray-300 dark:border-gray-600 focus:ring-primary-500'
            } bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 transition-colors`}
            required
          >
            <option value="">Seleziona...</option>
            <option value="titolare">Titolare</option>
            <option value="legale rappresentante">Legale Rappresentante</option>
          </select>
          {errors.role && (
            <p className="mt-1 text-sm text-red-600 dark:text-red-400">{errors.role}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PersonalDataSection;

